import * as _ from 'lodash';

export const SERVICE = {
  BLOCKBUSTER: 'blockbuster',
  SURELOCK: 'surelock',
};

export const PRESERVATION_STATUSES = {
  PROCESSING: 'PROCESSING',
  SUCCESSFUL: 'SUCCESSFUL',
  ERROR: 'ERROR',
  NOT_FOUND: 'CLOSED',
  DELETED: 'DELETED',
  NO_RECORDINGS: 'NO RECORDINGS',
};

export const VALID_PRESERVATION_STATUSES = _.values(_.omit(PRESERVATION_STATUSES, [PRESERVATION_STATUSES.NO_RECORDINGS]));

export const COMPRESSED_PRESERVATION_STATUSES = {
  PROCESSING: 'PROCESSING',
  SUCCESSFUL: 'SUCCESSFUL',
  NO_FILES_TO_COMPRESS: 'NO_FILES_TO_COMPRESS',
  ERROR: 'ERROR',
  NOT_FOUND: 'NOT_FOUND'
};

export const PRESERVATION_UPDATE_STATUSES = [
  'SUCCESSFUL',
  'CLOSED',
];

export const ZIP_FILE_FIELDS = {
  S3_FILE_NAME: 's3FileName',
  COMPRESSED_SIZE: 'compressedSize',
};

export const GET_PRESERVATIONS_LIMIT = 150;

// include these on every token request
export const ALL_SCOPES = Object.freeze({
  OPENID: 'openid',
  PROFILE: 'profile',
  EMAIL: 'email',
});

export const BLOCKBUSTER_SCOPES = Object.freeze({
  CREATE_DOWNLOAD: 'create:video-download',
  READ_METADATA: 'read:share-metadata',
  UPDATE_METADATA: 'update:share-metadata',
});

export const SURELOCK_SCOPES = Object.freeze({
  READ_PRESERVATION: 'read:video-preservation',
  CREATE_PRESERVATION: 'create:video-preservation',
  RETRIEVE_PRESERVATION: 'retrieve:video-preservation',
  DELETE_PRESERVATION: 'delete:video-preservation'
});

// scopes to include when requesting a token from blockbuster or surelock
export const DEFAULT_SCOPES = Object.values({ ...ALL_SCOPES, ...BLOCKBUSTER_SCOPES, ...SURELOCK_SCOPES }).join(' ');
